export const Code = (props: { json: any }) => (
  <pre>
    <code>{JSON.stringify(props.json, null, 2)}</code>
  </pre>
)
